<template>
  <div class="regform-ctr">
    <RfModalLoading :showDialog="showLoading > 0" />
    <RfRegister @submit="onRegister" />
    <v-dialog v-model="accountSuccessDialog" persistent width="600" overlayOpacity="0.85">
      <v-card flat>
        <v-card-title class="headline">Success!</v-card-title>
        <v-card-text class="create-new-promo-dialog">
          <span class="success-cre-msg">
            Your account has been successfully created. Please click on the verification link in
            your email to finish signing up.
          </span>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="x-large"
            variant="flat"
            color="success"
            width="170px"
            @click="continueToLogin"
            >Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RfRegister from "@/components/RfRegister.vue";
import { useUserStore } from "@/pinia/userStore";
import RfModalLoading from "./RfModalLoading.vue";

export default {
  components: { RfRegister, RfModalLoading },
  setup: () => ({ userStore: useUserStore() }),
  data: () => ({ accountSuccessDialog: false, showLoading: false }),
  created() {
    this.invitation_token = this.$route.query.invitation_token;
  },
  methods: {
    continueToLogin() {
      this.$router.push({ path: "/login" });
    },
    async onRegister(values) {
      this.showLoading = true;
      const response = await this.userStore.register({ ...values });
      this.showLoading = false;
      if (response) this.accountSuccessDialog = true;
    },
  },
};
</script>
<style scoped>
.success-cre-msg {
  font-size: 18px;
  padding: 10px 0 20px;
  display: block;
}
</style>
